<ion-app>
  <app-slide-menu></app-slide-menu>
</ion-app>
